import { render, staticRenderFns } from "./FormsBase.vue?vue&type=template&id=194bbd90&"
import script from "./FormsBase.vue?vue&type=script&lang=js&"
export * from "./FormsBase.vue?vue&type=script&lang=js&"
import style0 from "./FormsBase.vue?vue&type=style&index=0&id=194bbd90&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports